import { resolveBuildInfo } from '@inou/shared';

/**
 * このバンドルのビルド識別子。ビルド時に焼かれるので、実行時の取得は要らない。
 *
 * 運営パネルも同じバンドルなので、ここに焼かれた値がそのまま
 * 「配信している Worker と一緒にデプロイされた版数」になる
 * (SPA は Worker の assets として同時に出る)。
 */
export const BUILD_INFO = resolveBuildInfo({
  version: import.meta.env.VITE_INOU_VERSION,
  commit: import.meta.env.VITE_INOU_COMMIT,
  buildTime: import.meta.env.VITE_INOU_BUILD_TIME,
});
